let minOrderQty = 0;

document.addEventListener('DOMContentLoaded', function () {
    // Get the current URL path
    const currentPath = window.location.pathname;
    // get cobrand product ID
    const cpbid = document.querySelector('input[name="cbpid"]').value;
    // selected size container
    const selectedProductsContainer = document.getElementById('js-selected-product-container');
    
    //get minimum order quantity
    minOrderQty = Number(document.querySelector('input[name="cbpMinQty"]').value || 0);
    // set minimum order quantity in alert
    document.getElementById('minOrderQty').innerText = minOrderQty;
    //update number of color swatches
    const colorPicker = document.getElementById('js-carousel-colorpicker');
    Alpine.store('apparelStore').numberOfColorSwatches = colorPicker.querySelectorAll('.tag-carousel-cell').length;
    
    // add event listeners to the color swatches and get color ID
    const swatches = document.querySelectorAll('.tag-carousel-colorpicker .tag-carousel-cell');
    
    swatches.forEach( swatch => {
        swatch.addEventListener('click', () => {
            const colorId = swatch.getAttribute('data-colorid');
            getColorSizeGridHandler(currentPath, colorId, cpbid);
        })
    });
    
    async function getColorSizeGridHandler(currPath, color, productId){
        const fetchUrl = `${currPath}?handler=ApparelColorSize&productColorId=${color}&coBrandProductId=${productId}`;

        if (Alpine.store('apparelStore').selectedColorIdsSet.has(color)) {
            // TODO: Add Toast or Alert?
            console.log(`colorid="${color}" already exists. Skipping fetch.`);
            return;
        }
        
        try {
            const response = await fetch(fetchUrl);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.text();
            selectedProductsContainer.insertAdjacentHTML('beforeend', data);
            
            //add product Id to set so multiple copies are not added
            Alpine.store('apparelStore').selectedColorIdsSet.add(color);
            
            // hide color selector
            Alpine.store('apparelStore').showColorSelector = false;
            
        } catch (error) {
            console.error('Error fetching HTML:', error);
        }
    }
    
    
    // Add Logo Accordions Start
    // Select all accordion buttons inside the accordion container
    const accordionButtons = document.querySelectorAll('#js-bsAccordionArtwork .accordion-button');

    // Fetch Stock Art
    async function fetchStockArt(pageNum, catId = 0) {
        const container = document.getElementById('js-stock-art-content');
        const stockArtUrl = `/partial/clipartview?PageNumber=${pageNum}&categoryId=${catId}`; 
        try {
            const response = await fetch(stockArtUrl);
            if (!response.ok) {
                throw new Error(`HTTP stock art error! status: ${response.status}`);
            }
            const data = await response.text();
            container.innerHTML = data;
        }
        catch (error) {
            //TODO: Add error in display
            console.error('Error fetching Stock Art:', error);
        }
    };

    // Fetch Saved Art
    async function fetchSavedArt() {
        const container = document.getElementById('js-saved-art-content');
        const savedArtUrl = '/partial/myartworkview';

        if (container) {
            try {
                const response = await fetch(savedArtUrl);
                if (!response.ok) {
                    throw new Error(`HTTP saved art error! status: ${response.status}`);
                }
                const data = await response.text();
                container.innerHTML = data;
            }
            catch (error) {
                //TODO: Add error in display
                console.error('Error fetching Saved Art:', error);
            }
        }
    };

    accordionButtons.forEach(button => {
        const target = button.getAttribute('data-bs-target');
        const collapseElement = document.querySelector(target);
        const modifiedTarget = target.split('#js-').pop().toLowerCase();

        function executeFetch() {
            if (modifiedTarget === 'bssavedart') {
                fetchSavedArt();
            }

            if (modifiedTarget === 'bsstockart') {
                fetchStockArt(1);
            }
        }

        // CHECK IF ACCORDION IS OPEN (FOR ACE)
        if (collapseElement.classList.contains('show')){
            executeFetch()
        } else {
            button.addEventListener('click', () => {
                executeFetch()
            }, { once: true }); // adding once removes event listener after the first click
        }
    });
    // Add Logo Accordions End
    
    //Category select for Stock Art
    document.getElementById('js-bsStockArt').addEventListener('change', function(event){
        if (event.target.matches(".js-stockart-categorySelect")){
            const pageNumber = 1;
            const categoryId = event.target.value || 0;
            
            if (categoryId) {
                fetchStockArt(pageNumber, categoryId);
            }
        }
    });
    
    // Close Bootstrap Accordion
    function closeBSAccordion(id) {
        let collapseElement = document.getElementById(id);
        let bsCollapse = new bootstrap.Collapse(collapseElement, {
            toggle: false
        });
        // const accordionItem = collapseElement?.closest('.accordion-item');
        let accordionItem = null;

        if (collapseElement) {
            accordionItem = collapseElement.closest('.accordion-item');
        }

        bsCollapse.hide();

        // remove highlighted border from accordion 
        if (accordionItem) {
            accordionItem.classList.remove("border", "border-3");
        }
    }
    
    // Stock Art click events
    document.getElementById('js-bsStockArt').addEventListener('click', function(event){
        // Pagination for Stock Art
        if (event.target.matches(".page-link")){
            const pageNumber = event.target.getAttribute("data-pagenumber");
            const categoryId = event.target.getAttribute("data-categoryid") || 0;

            if (pageNumber) {
                fetchStockArt(pageNumber, categoryId);
            }
        }
        
        // handle clicks on stock art items
        const stockArtContainer = event.target.closest('.js-stock-art-item');
        if (stockArtContainer) {
            event.preventDefault();
                const categoryId = stockArtContainer.getAttribute("data-categoryid");
                const artCollectionId = stockArtContainer.getAttribute("data-artcollectionid");

                const imgElement = stockArtContainer.querySelector('img');
                const imgSrc = imgElement ? imgElement.src : null;
                if (categoryId && artCollectionId && imgSrc) {
                    Alpine.store('apparelStore').stockArtImage = {categoryId, artCollectionId, imgSrc};

                    // check if art was selected. If true, hide options
                    Alpine.store('apparelStore').checkIfAnyArtSelected();
                    
                    // collapse bootstrap accordion
                    closeBSAccordion('js-bsStockArt');
                }
            
        }
    });

    // Saved Art click events
    document.getElementById('js-bsSavedArt').addEventListener('click', function(event){
        const savedArtContainer = event.target.closest('.js-saved-art-item')
        if (savedArtContainer) {
            const documentId = savedArtContainer.getAttribute('data-documentid');
            const fileName = savedArtContainer.getAttribute('data-filename');
            let imgSrc = null;

            const imgElement = savedArtContainer.querySelector('img');
            if (imgElement) {
               imgSrc = imgElement.getAttribute('src');
            } else {
                imgSrc = '/images/icon-nopreview.svg'
            }

            Alpine.store('apparelStore').savedArtImage = {documentId, fileName, imgSrc};

            // check if art was selected. If true, hide options
            Alpine.store('apparelStore').checkIfAnyArtSelected();
            
            // collapse bootstrap accordion
            closeBSAccordion('js-bsSavedArt');
        }
    });
    

    // Alpine.data('imprintQtyManager', (root) => ({
    //     numberOfImprintColors: null,
    //
    //     async getColorDropdownHandler(){
    //         try {
    //             const store = Alpine.store('apparelStore');
    //             if (!store.numberOfImprintColors) return;  // Exit if there are no colors
    //
    //             const imprintColorsParams = store.imprintColors
    //             ? store.imprintColors.slice().reverse().map(c => `&selectColor=${c}`).join("")
    //                 : ""
    //
    //             const response = await fetch(`?handler=ImprintColors&qty=${store.numberOfImprintColors}${imprintColorsParams}`);
    //
    //             if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    //
    //             document.getElementById('js-color-select').innerHTML = await response.text();
    //         } catch (error) {
    //             console.error('Error fetching imprint colors dropdown:', error);
    //         }
    //     },
    //    
    //     init() {
    //         const colorSelect = root.querySelector('#imprintColorCountSelector');
    //
    //         //set color qty
    //         Alpine.store('apparelStore').numberOfImprintColors = Number(colorSelect.value || 0);
    //        
    //         // get initial color dropdown
    //         this.getColorDropdownHandler();
    //
    //         // Bind input change to select
    //         colorSelect.addEventListener('change', (event) => {
    //             this.numberOfImprintColors = Number(event.target.value || 0);
    //             //update global store
    //             Alpine.store('apparelStore').updateNumberOfImprintColors(Number(colorSelect.value || 0));
    //            
    //             // Get color dropdowns
    //             this.getColorDropdownHandler();
    //            
    //         });
    //     }
    // }));
    //
    // Alpine.data('imprintColorManager', (root) => ({
    //     selectedColorText: null,
    //     selectedColorHex: null,
    //     selectedColorId: null,
    //    
    //     selectColor(colorName, colorHex, colorId) {
    //         this.selectedColorText = colorName;
    //         this.selectedColorHex = `background-color: #${colorHex}; color: white;`;
    //         this.selectedColorId = colorId;
    //        
    //         const input = root.querySelector('input[name="colorvalue"]');
    //         input.value = this.selectedColorId;
    //         input.dataset.hex = colorHex;
    //         input.dataset.text = this.selectedColorText;
    //        
    //     },
    //     init(){
    //         // get initial values if edit
    //         const input = root.querySelector('input[name="colorvalue"]');
    //         if (input) {
    //             this.selectedColorId = input.value;
    //             this.selectedColorHex = input.dataset.hex
    //                 ? `background-color: #${input.dataset.hex}; color: white;`
    //                 : null;
    //             this.selectedColorText = input.dataset.text || null;
    //         }
    //     }
    //    
    // }));
});


